import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Facebook, Instagram, Star } from "lucide-react";
import SEO from "../components/SEO";
import { PHONE, PHONE_TEL, HOURS } from "../data/content";

export default function Contact() {
  return (
    <>
      <SEO
        title="Contact Tech Emergency | Adelaide Mobile IT — Call 1800 836 390"
        description="Contact Tech Emergency for fast, on-site computer repairs and IT support across Adelaide. Phone, online booking, social. Mon–Sat 9am–7pm."
        path="/contact"
      />
      <section className="pt-20 pb-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="te-overline mb-4">/ Get in touch</div>
          <h1 className="text-5xl sm:text-6xl font-bold tracking-tighter leading-none mb-6">
            One call.<br />Problem solved.
          </h1>
          <p className="text-zinc-400 max-w-2xl text-lg leading-relaxed">
            The fastest way to reach us is by phone — a real Adelaide-based human answers.
          </p>
        </div>
      </section>

      <section className="pb-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-6">
          <div className="te-card p-8">
            <Phone size={22} style={{ color: "var(--te-primary)" }} className="mb-4" />
            <div className="te-overline mb-2">/ Phone — fastest</div>
            <a href={PHONE_TEL} data-testid="contact-call-btn" className="text-3xl font-bold tracking-tight mb-3 block hover:text-[var(--te-primary)] transition-colors">
              {PHONE}
            </a>
            <p className="text-sm text-zinc-400">{HOURS}</p>
          </div>

          <div className="te-card p-8">
            <Mail size={22} style={{ color: "var(--te-primary)" }} className="mb-4" />
            <div className="te-overline mb-2">/ Send an enquiry</div>
            <h3 className="text-xl font-semibold mb-3">Prefer to type it out?</h3>
            <p className="text-sm text-zinc-400 mb-5">
              Fill the booking form — we'll call you back to confirm.
            </p>
            <Link to="/book" data-testid="contact-book-btn" className="te-btn te-btn-primary">Send an enquiry</Link>
          </div>

          <div className="te-card p-8">
            <MapPin size={22} style={{ color: "var(--te-primary)" }} className="mb-4" />
            <div className="te-overline mb-2">/ Service area</div>
            <h3 className="text-xl font-semibold mb-2">All of Adelaide metro</h3>
            <p className="text-sm text-zinc-400 mb-3">North · East · South · West · CBD</p>
            <p className="text-sm text-zinc-400 mb-5" data-testid="contact-area-note">
              Not sure if we service your area? Contact us to discuss your location and what you need help with.
            </p>
            <Link to="/suburbs" className="te-btn te-btn-ghost">See suburbs</Link>
          </div>

          <div className="te-card p-8">
            <Clock size={22} style={{ color: "var(--te-primary)" }} className="mb-4" />
            <div className="te-overline mb-2">/ Hours</div>
            <ul className="text-sm text-zinc-400 space-y-1.5">
              <li className="flex justify-between"><span>Mon – Sat</span><span className="text-white">9:00 AM – 7:00 PM</span></li>
              <li className="flex justify-between"><span>Sunday</span><span className="text-zinc-500">Closed</span></li>
            </ul>
          </div>

          <div className="te-card p-8 md:col-span-2">
            <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
              <div>
                <Star size={22} style={{ color: "var(--te-primary)" }} className="mb-4" />
                <div className="te-overline mb-2">/ Social</div>
                <h3 className="text-xl font-semibold mb-2">Follow us for tips & alerts</h3>
                <p className="text-sm text-zinc-400">New scam warnings, WiFi tips and Adelaide tech news.</p>
              </div>
              <div className="flex gap-3">
                <a href="https://www.facebook.com/profile.php?id=61570216282145" target="_blank" rel="noopener noreferrer" className="te-btn te-btn-ghost" data-testid="contact-fb">
                  <Facebook size={16} /> Facebook
                </a>
                <a href="https://www.instagram.com/techemergency" target="_blank" rel="noopener noreferrer" className="te-btn te-btn-ghost" data-testid="contact-ig">
                  <Instagram size={16} /> Instagram
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
